var _a;
export var AvailableFilters;
(function (AvailableFilters) {
    AvailableFilters[AvailableFilters["Project"] = 0] = "Project";
    AvailableFilters[AvailableFilters["LocationCountry"] = 1] = "LocationCountry";
    AvailableFilters[AvailableFilters["Race"] = 2] = "Race";
    AvailableFilters[AvailableFilters["Gender"] = 3] = "Gender";
    AvailableFilters[AvailableFilters["GenderPrimary"] = 4] = "GenderPrimary";
    AvailableFilters[AvailableFilters["Roles"] = 5] = "Roles";
    AvailableFilters[AvailableFilters["BusinessFunctions"] = 6] = "BusinessFunctions";
    AvailableFilters[AvailableFilters["BusinessSubFunctions"] = 7] = "BusinessSubFunctions";
    AvailableFilters[AvailableFilters["BusinessUnits"] = 8] = "BusinessUnits";
    AvailableFilters[AvailableFilters["Locations"] = 9] = "Locations";
    AvailableFilters[AvailableFilters["Industries"] = 10] = "Industries";
    AvailableFilters[AvailableFilters["JobLevels"] = 11] = "JobLevels";
    AvailableFilters[AvailableFilters["Ninebox"] = 12] = "Ninebox";
    AvailableFilters[AvailableFilters["NineboxRatings"] = 13] = "NineboxRatings";
    AvailableFilters[AvailableFilters["DerailerRisk"] = 14] = "DerailerRisk";
    AvailableFilters[AvailableFilters["CareerInterests"] = 15] = "CareerInterests";
    AvailableFilters[AvailableFilters["WillingToRelocate"] = 16] = "WillingToRelocate";
    AvailableFilters[AvailableFilters["Assessed"] = 17] = "Assessed";
    AvailableFilters[AvailableFilters["CareerTrack"] = 18] = "CareerTrack";
    AvailableFilters[AvailableFilters["SecurityClearance"] = 19] = "SecurityClearance";
    AvailableFilters[AvailableFilters["Retirement"] = 20] = "Retirement";
    AvailableFilters[AvailableFilters["LossImpact"] = 21] = "LossImpact";
    AvailableFilters[AvailableFilters["AssessmentSource"] = 22] = "AssessmentSource";
    AvailableFilters[AvailableFilters["RetentionRisk"] = 23] = "RetentionRisk";
    AvailableFilters[AvailableFilters["Division"] = 24] = "Division";
    AvailableFilters[AvailableFilters["AgeRange"] = 25] = "AgeRange";
    AvailableFilters[AvailableFilters["HighPotentialLeader"] = 26] = "HighPotentialLeader";
    AvailableFilters[AvailableFilters["HierarchyLeaderProfileIds"] = 27] = "HierarchyLeaderProfileIds";
    AvailableFilters[AvailableFilters["Managers"] = 28] = "Managers";
    AvailableFilters[AvailableFilters["CompanyName"] = 29] = "CompanyName";
    AvailableFilters[AvailableFilters["ProfileType"] = 30] = "ProfileType";
    AvailableFilters[AvailableFilters["PeoplePartner"] = 31] = "PeoplePartner";
    AvailableFilters[AvailableFilters["SelectedForTheRole"] = 32] = "SelectedForTheRole";
    AvailableFilters[AvailableFilters["AssessmentJourney"] = 33] = "AssessmentJourney";
    AvailableFilters[AvailableFilters["Spinner"] = 34] = "Spinner";
    AvailableFilters[AvailableFilters["Reset"] = 35] = "Reset";
    AvailableFilters[AvailableFilters["BusinessFunctionSuccessProfile"] = 36] = "BusinessFunctionSuccessProfile";
    AvailableFilters[AvailableFilters["BusinessSubFunctionSuccessProfile"] = 37] = "BusinessSubFunctionSuccessProfile";
    AvailableFilters[AvailableFilters["JobLevelSuccessProfile"] = 38] = "JobLevelSuccessProfile";
    AvailableFilters[AvailableFilters["RoleName"] = 39] = "RoleName";
    AvailableFilters[AvailableFilters["AssessmentCategory"] = 40] = "AssessmentCategory";
})(AvailableFilters || (AvailableFilters = {}));
export var dataFilters = (_a = {},
    _a[AvailableFilters.Project] = {
        entity: "project",
        key: AvailableFilters.Project,
        label: "Project",
    },
    _a[AvailableFilters.Locations] = {
        entity: "locations",
        key: AvailableFilters.Locations,
        label: "Location 1",
    },
    _a[AvailableFilters.LocationCountry] = {
        entity: "locationCountry",
        key: AvailableFilters.LocationCountry,
        label: "Location 2",
    },
    _a[AvailableFilters.BusinessUnits] = {
        entity: "businessUnits",
        key: AvailableFilters.BusinessUnits,
        label: "Business Unit",
    },
    _a[AvailableFilters.Division] = {
        entity: "division",
        key: AvailableFilters.Division,
        label: "Division",
    },
    _a[AvailableFilters.BusinessFunctions] = {
        entity: "businessFunctions",
        key: AvailableFilters.BusinessFunctions,
        label: "Function",
    },
    _a[AvailableFilters.BusinessSubFunctions] = {
        entity: "businessSubFunctions",
        key: AvailableFilters.BusinessSubFunctions,
        label: "Sub-Function",
    },
    _a[AvailableFilters.Roles] = {
        entity: "roles",
        key: AvailableFilters.Roles,
        label: "Role",
    },
    _a[AvailableFilters.JobLevels] = {
        entity: "jobLevels",
        key: AvailableFilters.JobLevels,
        label: "Level",
    },
    _a[AvailableFilters.Managers] = {
        entity: "managers",
        key: AvailableFilters.Managers,
        label: "Manager",
    },
    //role name
    _a[AvailableFilters.GenderPrimary] = {
        entity: "gender",
        key: AvailableFilters.GenderPrimary,
        label: "Gender",
    },
    _a[AvailableFilters.Gender] = {
        entity: "gender",
        key: AvailableFilters.Gender,
        label: "Gender",
    },
    _a[AvailableFilters.PeoplePartner] = {
        entity: "peoplePartner",
        key: AvailableFilters.PeoplePartner,
        label: "People Partner",
    },
    _a[AvailableFilters.SelectedForTheRole] = {
        entity: "selectedForTheRole",
        key: AvailableFilters.SelectedForTheRole,
        label: "Selected for Role",
    },
    _a[AvailableFilters.ProfileType] = {
        entity: "profileType",
        key: AvailableFilters.ProfileType,
        label: "Profile Type",
    },
    _a[AvailableFilters.Race] = {
        entity: "race",
        key: AvailableFilters.Race,
        label: "Ethnicity",
    },
    _a[AvailableFilters.Industries] = {
        entity: "industries",
        key: AvailableFilters.Industries,
        label: "Industries",
    },
    _a[AvailableFilters.Ninebox] = {
        entity: "9box",
        key: AvailableFilters.NineboxRatings,
        label: "9 Box Rating",
    },
    _a[AvailableFilters.NineboxRatings] = {
        entity: "9boxRatings",
        key: AvailableFilters.NineboxRatings,
        label: "9 Box Rating",
    },
    _a[AvailableFilters.DerailerRisk] = {
        entity: "derailerRisk",
        key: AvailableFilters.DerailerRisk,
        label: "Derailer Risk",
    },
    _a[AvailableFilters.CareerInterests] = {
        entity: "careerInterests",
        key: AvailableFilters.CareerInterests,
        label: "Career Interests",
    },
    _a[AvailableFilters.WillingToRelocate] = {
        entity: "willingToRelocate",
        key: AvailableFilters.WillingToRelocate,
        label: "Relocation Preferences",
    },
    _a[AvailableFilters.Assessed] = {
        entity: "assessed",
        key: AvailableFilters.Assessed,
        label: "Assessed",
    },
    _a[AvailableFilters.CareerTrack] = {
        entity: "careerTrack",
        key: AvailableFilters.CareerTrack,
        label: "Career Track",
    },
    _a[AvailableFilters.SecurityClearance] = {
        entity: "securityClearance",
        key: AvailableFilters.SecurityClearance,
        label: "Security Clearance",
    },
    _a[AvailableFilters.Retirement] = {
        entity: "retirement",
        key: AvailableFilters.Retirement,
        label: "Retirement",
    },
    _a[AvailableFilters.LossImpact] = {
        entity: "lossImpact",
        key: AvailableFilters.LossImpact,
        label: "Loss Impact",
    },
    _a[AvailableFilters.AssessmentSource] = {
        entity: "assessmentSource",
        key: AvailableFilters.AssessmentSource,
        label: "Assessment Source",
    },
    _a[AvailableFilters.RetentionRisk] = {
        entity: "retentionRisk",
        key: AvailableFilters.RetentionRisk,
        label: "Retention Risk",
    },
    _a[AvailableFilters.AssessmentJourney] = {
        entity: "assessmentJourney",
        key: AvailableFilters.AssessmentJourney,
        label: "Assessment Journey",
    },
    _a[AvailableFilters.AgeRange] = {
        entity: "ageRange",
        key: AvailableFilters.AgeRange,
        label: "Age",
    },
    _a[AvailableFilters.HighPotentialLeader] = {
        entity: "highPotentialLeader",
        key: AvailableFilters.HighPotentialLeader,
        label: "See only high potential talent",
    },
    _a[AvailableFilters.HierarchyLeaderProfileIds] = {
        entity: "hierarchyLeaderProfileIds",
        key: AvailableFilters.HierarchyLeaderProfileIds,
        label: "Hierarchy Leader Profile IDs",
    },
    _a[AvailableFilters.CompanyName] = {
        entity: "companyName",
        key: AvailableFilters.CompanyName,
        label: "Company Name",
    },
    _a[AvailableFilters.AssessmentCategory] = {
        entity: "assessmentCategory",
        key: AvailableFilters.AssessmentCategory,
        label: "Assessment Category",
    },
    _a);
var allEntitiesSet = new Set(Object.values(dataFilters).map(function (f) { return f.entity; }));
export var allEntities = {
    has: function (entity) { return allEntitiesSet.has(entity); },
};
export var getEntity = function (filter) {
    var _a;
    return (_a = dataFilters[filter]) === null || _a === void 0 ? void 0 : _a.entity;
};
/** Get display label for a dimension entity key (e.g. "project" -> "Project", "businessFunctions" -> "Function"). */
export var getLabelForEntity = function (entityKey) {
    var _a;
    var found = Object.values(dataFilters).find(function (f) { return f.entity === entityKey; });
    return (_a = found === null || found === void 0 ? void 0 : found.label) !== null && _a !== void 0 ? _a : entityKey;
};
/** Label for the "ALL" aggregate row/column for heatmap dimensions (Project, Function, Level, Location 1/2, Business Unit, Division, etc.). */
export var getAggregateLabelForEntity = function (entityKey) {
    var _a;
    var label = getLabelForEntity(entityKey);
    var aggregateLabels = {
        project: "All Projects",
        businessUnits: "All Business Units",
        businessFunctions: "All Functions",
        businessSubFunctions: "All Sub-Functions",
        jobLevels: "All Levels",
        locations: "All Location 1",
        locationCountry: "All Location 2",
        division: "All Divisions",
    };
    return (_a = aggregateLabels[entityKey]) !== null && _a !== void 0 ? _a : "All ".concat(label);
};
